import { AppBar, Badge, Button, Grid, Toolbar, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useGetButtonQuery } from '../../store/api/buttonApi'
import {
  backStep,
  createPrivileges,
  deletePrivileges,
  editPrivileges,
  nextStep,
  offNextButton,
  offRefreshButton,
  onNextButton,
  onRefreshButton,
  setSaveCheck,
  showButton,
} from '../../store/slice/buttonSlice'
import {
  showApproveDialog,
  showCreateDialog,
  showDeleteDialog,
  showHoldDialog,
  showListDialog,
  showLogDialog,
  showMatchDialog,
  showRejectDialog,
  showSaveAndCloseDialog,
  showSaveAndNewDialog,
  showSaveDialog,
  showSendToApproveDialog,
  showSubmitDialog,
  toggleChangeBankDialog,
  toggleCheckVendors,
  toggleConfirmDialog,
  toggleCopyRequestDialog,
  toggleCreatePODialog,
  toggleCreateRequest,
  toggleExcelImportDialog,
  togglePayDialog,
  togglePostToS,
  togglePrintDialog,
  toggleRetrieveDialog,
  toggleReturnToApprovedDialog,
  toggleSelectDialog,
  toggleSendtoBankDialog,
  toggleSubmitAndCreate,
  toggleTransferToSunsystemsDialog,
  toggleUploadDialog,
  toggleExcelDownloadDialog
} from '../../store/slice/dialogSlice'

import { Icon } from '@iconify/react'
import { useTranslation } from 'react-i18next'
import { showErrorToast } from '../../constToast/constToast'
import { isEmpty } from 'lodash'

import { updateOrderTabIndex, updatePaymentTabIndex } from '../../store/slice/tabIndexSlice'
import { updateRequestListData } from '../../store/slice/mainToCardSlice'

import { offCreateSup } from '../../store/slice/otherSlice'
import { LoadingButton } from '@mui/lab'
import { useGetAdditionalPrivilegeAccessQuery } from '../../store/api/menuApi'
import Language from '../../components/Language/Language'
import { useButtonConfig } from '../../config/buttonConfig'
import { updateRFQMainIdSlice } from '../../store/slice/bidsSlice'

const ButtonList = () => {
  const { t } = useTranslation('buttonList')
  const { t: r } = useTranslation('request')
  const { data: buttonData, refetch } = useGetButtonQuery()
  const editAccessGroup = buttonData?.data?.find((x) => x.menuId === 1002)?.editAccess
  const editAccessUser = buttonData?.data?.find((x) => x.menuId === 1001)?.editAccess

  const requestListData = useSelector((state) => state.mainToCard.requestListData)
  const bidsListData = useSelector((state) => state.mainToCard.bidsListData)
  const vendorRfqData = useSelector((state) => state.mainToCard.vendorRfqData)
  const dayjs = require('dayjs')
  const today = dayjs(new Date())
  const buttonConfig = useButtonConfig();
  const cardRequest = useSelector((state) => state.mainToCard.cardRequest)

  const url = useLocation().pathname
  const { dataId } = useParams()
  const navigate = useNavigate()

  const valid = useSelector(state => state.otherSlice.valid)
  const errorMessage = useSelector(state => state.otherSlice.errorMessage)
  const supNextButtonLoading = useSelector(state => state.otherSlice.supNextButtonLoading)

  const hiddenOrderSave = useSelector((state) => state.otherSlice.hiddenOrderSave)

  //Privleges
  const editPrivilegesData = useSelector((state) => state.buttonSlice.editData)
  const paymentCardDataSlice = useSelector((state) => state.paymentSlice.paymentCardDataSlice)
  const materialTableDataSlice = useSelector((state) => state.persistSlice.materialData)

  const paymentCardDataSliceHeader = paymentCardDataSlice?.header

  const paymentCardSlice = useSelector((state) => state.paymentSlice.paymentCardSlice)
  const userMainTab = useSelector((state) => state.tabIndexSlice.userTabIndex)
  const vendorTabIndex = useSelector((state) => state.tabIndexSlice.vendorTabIndex)
  const requestTabIndex = useSelector((state) => state.persistSlice.requestTabIndex)
  const paymentTabIndex = useSelector((state) => state.tabIndexSlice.paymentTabIndex)
  const rfqTabIndex = useSelector((state) => state.tabIndexSlice.rfqsTabIndex)
  const orderTabIndex = useSelector((state) => state.tabIndexSlice.orderTabIndex)
  const invoiceRegisterTabValue = useSelector((state) => state.invoiceSlice.invoiceRegisterTabValue)
  const invoiceMatchTabs = useSelector((state) => state.invoiceSlice.invoiceMatchTabValue)
  const selectedMatchData = useSelector((state) => state.invoiceSlice.selectedMatchData)

  const differenceRequests = useSelector((state) => state.rfqSlice.differenceRequests)
  const selectedRequests = useSelector((state) => state.rfqSlice.selectedRequests)
  const selectedRFQS = useSelector((state) => state.rfqSlice.selectedRFQs)
  const selectedBidComparsionGridData = useSelector((state) => state.bidComparsionSlice.selectedGridData)
  const bidComparisonTabIndex = useSelector((state) => state.bidComparsionSlice.bidComparsionTab)
  const selectedBidComparisonLines = useSelector((state) => state.bidComparsionSlice.selectedLines)
  const comparsionChartData = useSelector((state) => state.bidComparsionSlice.comparsionChartData)
  const registerInvoiceData = useSelector((state) => state.invoiceSlice.registerInvoiceData)
  const selectedMaterialData = useSelector((state) => state.persistSlice.selectedMaterialData)
  const selectedSequenceFromWFA = useSelector((state) => state.bidComparsionSlice.selectedSequenceFromWFA)
  const attachmentCount = useSelector((state) => state.mainToCard.attachmentCount)

  const invoiceMain = useSelector((state) => state.mainToCard.invoiceMain)
  const allDraft = invoiceMain.every((item) => item.statusName === 'Draft')

  const analysisStructureData = useSelector((state) => state.mainToCard.analysisStructureData)
  const analysisDimensionData = useSelector((state) => state.mainToCard.analysisDimensionData)
  const analysisCodeData = useSelector((state) => state.mainToCard.analysisCodeData)

  const userInfo = useSelector((state) => state.mainToCard.userInfo)

  const userData = useSelector((state) => state.mainToCard.userData)
  const groupData = useSelector((state) => state.mainToCard.groupData)
  const requestData = useSelector((state) => state.persistSlice.requestData)
  const paymentData = useSelector((state) => state.persistSlice.paymentData)
  const rfqsData = useSelector((state) => state.mainToCard.rfqsData)
  const bidsData = useSelector((state) => state.mainToCard.bidsData)
  const vendorData = useSelector((state) => state.mainToCard.vendorData)
  const orderData = useSelector((state) => state.mainToCard.orderData)
  const orderBuId = useSelector((state) => state.persistSlice.orderBuId)
  const activeStep = useSelector((state) => state.buttonSlice.activeStep)
  const invoiceMatchData = useSelector((state) => state.invoiceSlice.invoiceMatchData)
  const invoiceNumber = useSelector((state) => state.invoiceSlice.invoiceNumber)
  const refreshButtonList = useSelector((state) => state.buttonSlice.refreshButtonList)
  const invoiceOutstandingData = useSelector((state) => state.invoiceSlice.invoiceOutstandingData)
  const invoiceMatchTabValue = localStorage.getItem('invoiceMatchTabValue')
  const isAllowMatched = Boolean(
    (invoiceOutstandingData.grnAmount &&
      (invoiceOutstandingData.invoiceAmount || invoiceOutstandingData.advanceInvoicesAmount) &&
      invoiceOutstandingData.outstanding >= -1 && invoiceOutstandingData.outstanding <= 1)
  )

  const { data: additionalPrivilegeData } = useGetAdditionalPrivilegeAccessQuery()
  const checkAdditionalPrivilegeOrder = additionalPrivilegeData?.data.some(item => {
    return item.additionalPrivelegeName === "Create Order"
  })

  const checkAdditionalPrivilegeRequestRetrieve = additionalPrivilegeData?.data.some(item => {
    return item.additionalPrivelegeName === "Retrieve Requests"
  })
  const individualBool = useSelector(state => state.otherSlice.individualBool)

  // Redux
  const dispatch = useDispatch()

  const clickHandlers = {
    handleAddItem: () => {
      dispatch(showListDialog())
    },
    handleApprove: () => {
      dispatch(showApproveDialog())
    },
    handleHold: () => {
      dispatch(showHoldDialog())
    },
    handleReject: () => {
      dispatch(showRejectDialog())
    },
    handleSave: () => {
      dispatch(showSaveDialog())
    },
    handleSaveAndClose: () => {
      dispatch(showSaveAndCloseDialog())
    },
    handleSaveAndNew: () => {
      dispatch(showSaveAndNewDialog())
    },
    handleSubmit: () => {
      dispatch(showSubmitDialog())
    },
    handleLog: () => {
      dispatch(showLogDialog())
    },
    handleRefresh: () => {
      dispatch(onRefreshButton())
      setTimeout(() => {
        dispatch(offRefreshButton(false))
      }, 1)
    },
    handleExcelTemplateDownload: async () => {
      switch (url) {
        case `/orders/${dataId}`:
          dispatch(toggleExcelDownloadDialog())
          // window.location.href = `${process.env.REACT_APP_FILE_API_URL}home/module/ImportTemplates/fileName/POImport.xlsm/download`
          break
        case `/invoice-match/${dataId}`:

          // window.location.href = `${process.env.REACT_APP_FILE_API_URL}home/module/ImportTemplates/fileName/POImport.xlsm/download`
          break
        default:
          break
      }
    },
    handleCreateOrderWithoutPO: () => {
      navigate(`/orders/0`)
      dispatch(updateOrderTabIndex('6'))
      dispatch(updateRequestListData([]))
    },
    handleImportExcelFile: () => {
      dispatch(toggleExcelImportDialog())
    },
    handleShow: () => {
      dispatch(showButton())
    },
    handleCreate: () => {
      if (url === '/users') {
        navigate('/users/0')
        return
      }
      if (url === '/groups') {
        navigate('/groups/0')
        return
      }
      if (url === '/orders') {
        navigate('/ordersList')

        dispatch(updateOrderTabIndex('6'))
        return
      }
      if (url === '/payment') {
        navigate('/payment-create')
        return
      }
      dispatch(showCreateDialog())
    },
    handleCreateRequest: () => {
      dispatch(toggleCreateRequest())
    },
    handleUploadDialog: () => {
      dispatch(toggleUploadDialog())
    },

    handleCreateDocument: () => {
      navigate(`/payment/${0}`)
    },

    handleDelete: () => {
      switch (url) {
        case '/requests':
          dispatch(showDeleteDialog())
          break
        default:
          dispatch(showDeleteDialog())
          break
      }
    },

    handleSendToApprovals: () => {
      dispatch(showSendToApproveDialog())
    },
    handleEdit: () => {
      switch (url) {
        case '/users':
          userData[0] ? navigate(`/users/${userData[0].id}`) : showErrorToast('Not Found')
          break
        case '/groups':
          groupData[0] ? navigate(`/groups/${groupData[0].groupId}`) : showErrorToast('Not Found')
          break
        case '/requests':
          if (requestData?.length > 1) {
            showErrorToast('It is possible to edit only one Request')
            return
          }
          requestData?.[0]
            ? navigate(`/requests/${requestData && requestData?.[0]?.requestMainId}`)
            : showErrorToast('Not Found')
          break
        case '/rfqs':
          if (selectedRFQS.length > 1) {
            showErrorToast('It is possible to edit only one RFQ')
            return
          }
          rfqsData[0] ? navigate(`/rfqs/${rfqsData[0].id}`) : showErrorToast('Please select line RFQ')
          break
        case '/bid-comparison':
          if (selectedBidComparsionGridData.length > 1) {
            showErrorToast('It is possible to edit only one Comparison')
            return
          }
          selectedBidComparsionGridData[0]
            ? navigate(`/bid-comparison/${selectedBidComparsionGridData[0].rfqMainId}`)
            : showErrorToast('Please select line Comparison')
          break

        case '/bids':
          const id = bidsData?.id
          id ? navigate(`/bids/${id}`) : showErrorToast('Bids data not found')
          break
        case '/vendors':
          vendorData[0] ? navigate(`/vendors/${vendorData[0].vendorId}`) : showErrorToast('Not Found')
          break
        case '/orders':
          if (orderData?.length > 1) {
            showErrorToast('It is possible to edit only one Order')
            return
          }
          orderData[0] ? navigate(`/orders/${orderData[0].orderMainId}`) : showErrorToast('Please select an Order')
          break
        default:
          showErrorToast('Not Found')
          break
      }
    },
    handleNext: () => {
      dispatch(setSaveCheck(true))
    },

    handleNextSup: () => {
      dispatch(onNextButton())
    },

    handleBackSup: () => {
      if (activeStep > 0) {
        dispatch(backStep());
      } else {

      }

    },

    // dispatch(updatePaymentCardSlice({ ...paymentCardSlice, businessUnitId }))
    handleBack: () => {
      switch (url) {
        case '/evaluation-form':
          if (activeStep === 0) {
            navigate(-1)
          } else {
            dispatch(backStep())
          }
          break
        case `/select-request/${dataId}`:
          navigate(`/rfqs/${dataId}?fromRequest=true`)
          break

        case `/requests/${dataId}`:
          navigate(`/requests`)
          break


        case `/invoice-match/${dataId}`:
          navigate(`/invoice-match`)
          break

        case `/bids/${dataId}`:
          navigate(`/rfq-information`)
          dispatch(updateRFQMainIdSlice(null))
          break

        // case `/bids/${dataId}`:
        //   navigate(`/bids`)
        //   break

        default:
          navigate(-1)
          break
      }
    },
    handleCheckVendors: () => {
      if (!rfqsData.length) {
        showErrorToast('Not Found')
        return
      }
      dispatch(toggleCheckVendors())
    },
    handleSelect: () => {
      dispatch(toggleSelectDialog())
    },
    handlepostToS: () => {
      dispatch(togglePostToS())
    },
    handlePrint: () => {
      dispatch(togglePrintDialog())

      if (url.includes("orders")) {
        if (orderBuId === 1) {
          window.open(("/reporting/viewer/:name/:id").replace(':name', 'OrderPrintTOC').replace(':id', orderData[0]?.orderMainId), '_blank');
        } else if (orderBuId === 4) {
          window.open(("/reporting/viewer/:name/:id").replace(':name', 'OrderPrintSOC').replace(':id', orderData[0]?.orderMainId), '_blank');
        } else {
          window.open(("/reporting/viewer/:name/:id").replace(':name', 'OrderPrint').replace(':id', orderData[0]?.orderMainId), '_blank');
        }
      } else if (url.includes("requests")) {
        window.open(("/reporting/viewer/:name/:id").replace(':name', 'RequestPrint').replace(':id', requestData[0]?.requestMainId), '_blank');
      } else if (url.includes("rfqs")) {
        window.open(("/reporting/viewer/:name/:id").replace(':name', 'RfqPrint').replace(':id', rfqsData[0]?.id), '_blank');
      }

    },
    handleConfirm: () => {
      dispatch(toggleConfirmDialog())
    },
    handleCopyRequest: () => {
      dispatch(toggleCopyRequestDialog())
    },
    handleCreatePO: () => {
      dispatch(toggleCreatePODialog())
    },
    handleRetrieve: () => {
      dispatch(toggleRetrieveDialog())
    },
    handleReturnToApproved: () => {
      dispatch(toggleReturnToApprovedDialog())
    },
    handleChangeBank: () => {
      dispatch(toggleChangeBankDialog())
    },
    handleSendtoBank: () => {
      dispatch(toggleSendtoBankDialog())
    },
    handlePay: () => {
      dispatch(togglePayDialog())
    },

    handleSubmitAndCreate: () => {
      dispatch(toggleSubmitAndCreate())
    },
    handleTransferToSunsystems: () => {
      dispatch(toggleTransferToSunsystemsDialog())
    },
  }
  const [conditionDynamic, setConditionDynamic] = useState([])
  useEffect(() => {
    const newConditionDynamic =
      buttonData?.data?.map((item, index) => {
        if (item.url === url && item.createAccess) {
          dispatch(createPrivileges())
        }
        if (item.url === url && item.editAccess) {
          dispatch(editPrivileges())
        }
        if (item.url === url && item.deleteAccess) {
          dispatch(deletePrivileges())
        }
        return {
          createRequest: () => item.url === url && item.createAccess && url === '/requests',
          create: () =>
            item.url === url &&
            item.createAccess &&
            url !== '/analysis-codes' &&
            url !== '/analysis-dimensions' &&
            url !== '/analysis-structures' &&
            url !== '/approval-roles' &&
            url !== '/requests' &&
            url !== '/invoice-register' &&
            url !== '/supplier-evaluation' &&
            url !== '/invoice-match' &&
            url !== '/rfq-information' &&
            url !== '/approval-roles',
          edit: () =>
            item.url === url &&
            item.editAccess &&
            url !== '/analysis-codes' &&
            url !== '/analysis-dimensions' &&
            url !== '/analysis-structures' &&
            url !== '/approval-roles' &&
            url !== '/approval-roles' &&
            url !== '/approval-stages' &&
            url !== '/payment' &&
            url !== '/rfq-information' &&
            url !== '/evaluation-form' &&
            url !== '/supplier-evaluation' &&
            url !== '/invoice-match' &&
            (url !== '/requests' || requestTabIndex !== '2') &&
            url !== '/invoice-register',
          delete: () =>
            item.url === url &&
            item.deleteAccess &&
            url !== '/analysis-codes' &&
            url !== '/analysis-dimensions' &&
            url !== '/analysis-structures' &&
            url !== '/supplier-evaluation' &&
            url !== '/rfq-information' &&
            url !== '/approval-roles' &&
            (url !== '/orders' || orderTabIndex === '6') &&
            url !== '/invoice-match' &&
            (url !== '/requests' || requestTabIndex === '5') &&
            url !== '/invoice-register',

          // && (url === '/invoice-register' && item?.url === url && invoiceRegisterTabValue == '1')
        }
      }) || []
    setConditionDynamic(newConditionDynamic)
  }, [buttonData, dispatch, url, invoiceRegisterTabValue, orderTabIndex, invoiceMatchTabs, requestTabIndex])

  useEffect(() => {
    refetch()
  }, [refreshButtonList, refetch])
  const combinedChangeStatusButtons = () => {
    return (
      (userData[0] && userMainTab === '1' && url === '/users') ||
      (userMainTab === '1' && url === `/users/${dataId}` && dataId !== '0') ||
      (vendorData[0] && (vendorTabIndex === '1' || vendorTabIndex === '5') && url === '/vendors') ||
      (requestData?.[0] &&
        (requestTabIndex === '1' || requestTabIndex === '3' || requestTabIndex === '4') &&
        url === '/requests') ||
      ((requestTabIndex === '1' || requestTabIndex === '4') &&
        cardRequest?.status != 1 &&
        (selectedMaterialData !== null) && selectedMaterialData?.[0] !== undefined &&
        dataId > 0 &&
        url === `/requests/${dataId}`) ||
      ((orderTabIndex === '1' || orderTabIndex === '3' || orderTabIndex === '4') &&
        orderData[0] &&
        url === '/orders') ||
      ((orderTabIndex === '1' || orderTabIndex === '3' || orderTabIndex === '4') &&
        url === `/orders/${dataId}` &&
        dataId !== '0') ||
      (paymentData?.[0] && paymentTabIndex === '2' && url === '/payment')
    )
  }

  const createSup = useSelector(state => state.otherSlice.createSup)
  const reviseSup = useSelector(state => state.otherSlice.reviseSup)
  const readSup = useSelector(state => state.otherSlice.readSup)
  const loadingSubmitAndCreate = useSelector(state => state.otherSlice.loadingSubmitAndCreate)

  const conditionStatic = {
    approve: combinedChangeStatusButtons,
    hold:
      url === `/bid-comparison/${dataId}` ||
        url === '/users' ||
        url === `/users/${dataId}` ||
        (url === `/requests` && requestTabIndex === '4') ||
        ((url === `/orders/${dataId}` || url === `/orders`) && orderTabIndex === '4')
        ? () => {
          return selectedSequenceFromWFA
        }
        : combinedChangeStatusButtons,
    reject:
      (url === `/bids/${dataId}` && (vendorRfqData[0]?.participationStatus == 'Issued' && dayjs(vendorRfqData[0]?.rfqDeadline).isAfter(today))) ? () => combinedChangeStatusButtons
        : combinedChangeStatusButtons,
    save: () =>
      url === (editAccessUser && `/users/${dataId}`) ||
      url === (editAccessUser && `/user/${dataId}`) ||
      url === (editAccessGroup && `/groups/${dataId}`) ||
      url === '/analysis-codes' ||
      url === '/analysis-dimensions' ||
      url === '/analysis-structures' ||
      url === '/approval-roles' ||
      url === '/approval-roles' ||
      url === `/approval-stages/${dataId}` ||
      url === `/approval-stages/${dataId}` ||
      (((localStorage.getItem('isRevise') && editPrivilegesData && localStorage.getItem('readOnlyData') !== 'true') ||
        localStorage.getItem('isAuthentication') === 'true' && localStorage.getItem('reviseId') != 0) &&
        url === `/evaluation-form`) ||
      // (url === `/supplier-evaluation` && (!createSup && !reviseSup) && !supNextButtonLoading) ||
      // (url === `/supplier-evaluation/${dataId}` && ((!createSup || dataId === '0') && !reviseSup) && !supNextButtonLoading) ||

      (requestTabIndex !== '2' && url === `/requests/${dataId}`) || url === `/requests/0` ||
      (url === `/bids/${dataId}` && (vendorRfqData[0]?.participationStatus == 'In Process' || vendorRfqData[0]?.participationStatus == 'Accepted')) ||
      (url === `/orders/${dataId}` && (orderTabIndex === '6' || orderTabIndex === '1' || hiddenOrderSave)) ||
      url === `/orders/0` ||
      (url === `/rfqs/${dataId}` && (rfqsData?.[0]?.status === 0 || dataId == 0)) ||
      (url === `/bid-comparison/${dataId}` && selectedBidComparsionGridData?.[0]?.status === 0),

    //|| url === `/invoice-match/${dataId}`,
    log: () =>
      url === '/payment' ||
      url === `/payment/${dataId}` ||
      (url === '/users' && userData[0]) ||
      (url === '/groups' && groupData[0]) ||
      (url === '/orders' && orderData[0]) ||
      url === '/analysis-codes' ||
      url === '/analysis-codes' ||
      url === '/analysis-dimensions' ||
      url === '/analysis-structures' ||
      url === '/approval-roles' ||
      url === '/approval-roles' ||
      url === '/approval-stages' ||
      url === `/approval-stages/${dataId}` ||
      (url === `/vendors` && vendorData[0]) ||
      url === '/requests' ||
      url === `/requests/${dataId}` ||
      url === '/bids' ||
      url === `/bids/${dataId}` ||
      (url === '/rfqs' && rfqsData.length) ||
      (url === `/rfqs/${dataId}` && dataId != 0) ||
      (url === '/bid-comparison' && selectedBidComparsionGridData.length) ||
      (url === `/bid-comparison/${dataId}` && dataId != 0) ||
      url === `/invoice-register` ||
      url === `/orders/${dataId}` ||
      url === 'log',
    // saveAndNew: () =>
    //   url === `/approval-stages/${dataId}` ||
    //   url === `/requests/${dataId}` ||
    //   (url === `/rfqs/${dataId}` && (rfqsData?.[0]?.status === 0 || dataId == 0)),


    print: () =>
      (url === '/orders' && orderData[0] && orderData?.length === 1 && orderTabIndex === '2' && orderData[0]?.approveStatus === 'Approved') ||
      (url === '/rfqs' && rfqsData[0] && rfqsData?.length === 1) ||
      (url === '/requests' && requestData[0] && requestData?.length === 1)
    ,
    refresh: () =>
      url === `/users/${dataId}` ||
      url === `/groups/${dataId}` ||
      url === `/vendors` ||
      // url === `/vendors/${dataId}` ||
      url === '/requests' ||
      (dataId == 0 && url === `/requests/${dataId}`) ||
      url === '/bids' ||
      url === `/bids/${dataId}` ||
      url === `/payment-create` ||
      url === '/rfqs' ||
      url === `/select-request/${dataId}` ||
      // url === `/orders` ||
      // url === `/orders/${dataId}` ||
      url === `/rfqs/${dataId}` ||
      url === `/bid-comparison` ||
      url === `/invoice-register` ||
      url === '/payment' ||
      url === `/payment/${dataId}` ||
      url === '/payment-pay' ||
      url === `/payment-pay/${dataId}` ||
      url === `/invoice-match` ||
      url === `/rfq-information` ||
      (url === `/invoice-match/${dataId}`),
    excelTemplateDownload: () => (dataId == 0 && url === `/orders/${dataId}`) || (url === `/invoice-match/${dataId}` && invoiceMatchData?.length > 0),
    createOrderWithoutPO: () => url === `/orders` && checkAdditionalPrivilegeOrder,
    importExcelFile: () => (dataId == 0 && url === `/orders/${dataId}`) || (url === `/invoice-match/${dataId}` && invoiceMatchData?.length > 0),
    next: () => (url === `/evaluation-form`) && activeStep !== 4,
    backStep: () => url === `/evaluation-form`,

    nextSup: () => (url === `/supplier-evaluation` && activeStep !== 4 && !supNextButtonLoading) || (url === `/supplier-evaluation/${dataId}` && activeStep !== 4 && !supNextButtonLoading),
    backSup: () => url === `/supplier-evaluation` || url === `/supplier-evaluation/${dataId}`,

    submit: () =>
      (url === `/select-request/${dataId}` && !differenceRequests.length && selectedRequests.length)
      || (url === `/supplier-evaluation` && !readSup && activeStep === 4 && !supNextButtonLoading)
      || (url === `/supplier-evaluation/${dataId}` && !readSup && activeStep === 4 && !supNextButtonLoading)
      || ((url === `/bids/${dataId}` && (vendorRfqData[0]?.participationStatus == 'In Process' || vendorRfqData[0]?.participationStatus == 'Accepted')))
      || (url === `/supplier-evaluation` && individualBool && activeStep === 3 && !supNextButtonLoading),
    back: () => true,
    attachment: () =>
      url === `/requests/${dataId}` ||
      url === `/bids/${dataId}` ||
      url === `/rfqs/${dataId}` ||
      url === `/bid-comparison/${dataId}` ||
      // url === `/invoice-register` ||
      url === `/orders/${dataId}`,
    import: () => url === '/requests',
    createDocument: () => url === '/payment-create',
    // report: () => url === '/requests' || url === '/bids',
    sendToApprovals: () =>
      // (url === `/vendors` && vendorTabIndex === '6' && vendorData[0]) ||
      (url === `/orders` && orderTabIndex === '6' && orderData[0]) ||
      (requestData?.[0] && requestTabIndex === '5' && url === '/requests') ||
      (url === `/bid-comparison/${dataId}` &&
        selectedBidComparsionGridData?.[0]?.status == 0 &&
        selectedBidComparsionGridData?.[0]?.approveStageMain != 0) ||
      // (url === '/invoice-register' && localStorage.getItem(LOCALSTORAGE_INVOICE_TAB) === '3' && invoiceMain[0]) ||
      (paymentData?.[0] && paymentTabIndex === '1' && url === '/payment'),
    delete: () =>
      (url === `/rfqs/${dataId}` && dataId != 0),
    checkVendors: () =>
      (rfqTabIndex === '2' && url === `/rfqs`) ||
      (url === `/rfqs/${dataId}` && dataId != 0 && rfqsData?.[0]?.status == 0),
    createPO: () => url === `/bid-comparison/${dataId}` && bidComparisonTabIndex == 7,
    addItem: () => url === `/bids/${dataId}` && !parseInt(dataId) && !window.location.href.includes('fromVendor'),
    select: () => (requestListData?.length > 0 && url === `/ordersList`) || (bidsListData?.length > 0 && url === `/ordersList`),
    confirm: () => {
      let bidApprovals = comparsionChartData?.bids ? [...comparsionChartData?.bids?.map((x) => x?.bidApprovals)] : [];
      const length = [].concat(...bidApprovals).filter((x) => x?.approveStatus == 2)?.length;

      return (
        (
          url === `/bid-comparison/${dataId}` ||
          (url === `/bids/${dataId}` && (vendorRfqData[0]?.participationStatus == 'Issued' && dayjs(vendorRfqData[0]?.rfqDeadline).isAfter(today)))
        )
      );
    },
    sendtoBank: () => paymentTabIndex === '3' && url === '/payment',
    retrieve: () =>
      (paymentTabIndex !== '1' && paymentTabIndex !== '8' && url === '/payment') ||
      (requestTabIndex !== '5' && checkAdditionalPrivilegeRequestRetrieve && requestData?.length > 0 && url === '/requests' &&
        requestData?.length === 1 &&
        (requestData[0]?.statusName !== 'Converted' && requestData[0]?.statusName !== 'Partly Converted')) || (url == '/rfq-information' && vendorRfqData[0]?.participationStatus == 'Submitted' && vendorRfqData[0]?.rfqStatus == 'Open') ||
      ((orderTabIndex === '1' || orderTabIndex === '2' || orderTabIndex === '3' || orderTabIndex === '4' || orderTabIndex === '5') &&
        url === '/orders'),
    returnToApproved: () => paymentTabIndex === '7' && url === '/payment',
    pay: () => paymentTabIndex === '7' && url === '/payment',
    changeBank: () => paymentTabIndex === '8' && url === '/payment',
    show: () => url === `/payment-pay/${dataId}`,
    postToS: () => url === `/payment-pay/${dataId}`,
    copyRequest: () => dataId != 0 && url === `/requests/${dataId}`,
    // print: () => requestListData.length > 0 && url === `/ordersList`,
    // devMode: () => url === `/ vendors / ${ dataId } `,
    action: () => url === '/invoice-match',
    matchInvoice: () => url === `/invoice-match/${dataId}` && invoiceNumber,
    submitAndCreate: () => url === `/invoice-match/${dataId}`
    // transferToSunsystems: () => userInfo.userType === 1 && url === `/vendors/${dataId}`,
  }


  const renderedDynamicButton = (
    <Grid container>
      {conditionDynamic.map((condition, index) => {
        return Object.keys(condition).map((type) => {
          const button = buttonConfig[type]
          button.text = `${t(`${type}`)}`
          return (
            button &&
            condition[type]() && (
              <div key={button.id}>
                <Button
                  onClick={() => clickHandlers[button.onClick](button.id)}
                  sx={{ pl: 2 }}
                  size="small"
                  startIcon={button.icon}
                >
                  <Typography
                    sx={{
                      display: { xs: 'none', md: 'block' },
                      color: 'black',
                    }}
                  >
                    {button.text}
                  </Typography>
                </Button>
              </div>
            )
          )
        })
      })}
    </Grid>
  )
  const renderedStaticButton = (
    <Grid container display="flex" alignItems="center">
      {Object.values(buttonConfig).map((button) => {
        if (conditionStatic[button?.id] && conditionStatic[button?.id]()) {

          if (
            button.id === 'backSup' &&
            (url === '/supplier-evaluation' || url === `/supplier-evaluation/${dataId}`) &&
            activeStep === 0
          ) {
            return null;
          }


          return (
            <div key={button.id}>
              {button.id === 'attachment' ? (
                <Badge badgeContent={attachmentCount} color="primary">
                  <Button
                    onClick={() => clickHandlers[button.onClick](button.id)}
                    sx={{ pl: 2 }}
                    size="small"
                    startIcon={button.icon}
                  >
                    <Typography
                      sx={{
                        display: { xs: 'none', md: 'block' },
                        color: 'black',
                      }}
                    >
                      {t(button.text)}
                    </Typography>
                  </Button>
                </Badge>
              ) : button.id === 'createDocument' ? (
                // New condition for 'createDoc' button
                <Button
                  onClick={() => clickHandlers[button.onClick](button.id)}
                  sx={{ pl: 2 }}
                  size="small"
                  startIcon={button.icon}
                  disabled={isEmpty(paymentCardSlice?.details) ? true : false}
                >
                  <Typography
                    sx={{
                      display: { xs: 'none', md: 'block' },
                      color: 'black',
                    }}
                  >
                    {t(button.text)}
                  </Typography>
                </Button>
              ) : button.id === 'matchInvoice' ? (
                <Button
                  onClick={() => clickHandlers[button.onClick](button.id)}
                  sx={{ pl: 2 }}
                  size="small"
                  startIcon={
                    <Icon icon="fa-solid:receipt" color={isAllowMatched ? '#699BF7' : '#aaa'} width="20" height="20" />
                  }
                  disabled={!isAllowMatched}
                >
                  <Typography
                    sx={{
                      display: { xs: 'none', md: 'block' },
                      color: 'black',
                    }}
                  >
                    {t(button.text)}
                  </Typography>
                </Button>
              ) : button.id === 'action' ? (
                <Button
                  onClick={() => clickHandlers[button.onClick](button.id)}
                  sx={{ pl: 2 }}
                  size="small"
                  startIcon={
                    <Icon
                      icon="fa6-solid:circle-info"
                      color={isEmpty(selectedMatchData) ? '#aaa' : '#699BF7'}
                      width="20"
                      height="20"
                    />
                  }
                  disabled={isEmpty(selectedMatchData)}
                >
                  <Typography
                    sx={{
                      display: { xs: 'none', md: 'block' },
                      color: 'black',
                    }}
                  >
                    {t(button.text)}
                  </Typography>
                </Button>
              )
                : button.id === 'submitAndCreate' ? (
                  <LoadingButton
                    disabled={loadingSubmitAndCreate}
                    loading={loadingSubmitAndCreate}
                    loadingPosition="start"
                    startIcon={button.icon}
                    onClick={() => clickHandlers[button.onClick](button.id)}
                  >
                    <Typography
                      sx={{
                        display: { xs: 'none', md: 'block' },
                        color: 'black',
                      }}
                    >
                      {t(button.text)}
                    </Typography>
                  </LoadingButton>
                )
                  : (
                    // Default condition for other buttons
                    <Button
                      onClick={() => clickHandlers[button.onClick](button.id)}
                      sx={{ pl: 2 }}
                      size="small"
                      startIcon={button.icon}
                    >
                      <Typography
                        sx={{
                          display: { xs: 'none', md: 'block' },
                          color: 'black',
                        }}
                      >
                        {t(button.text)}
                      </Typography>
                    </Button>
                  )}
            </div>
          )
        } else {
          return null
        }
      })}
    </Grid>
  )

  let name
  switch (url) {
    case '/users':
      name = 'Users List'
      break
    case `/users/${dataId}`:
      name = 'User Card'
      break
    case '/groups':
      name = 'User Groups'
      break
    case `/groups/${dataId}`:
      name = 'User Group Card'
      break
    case '/analysis-codes':
      name = 'Analysis Codes'
      break
    case '/analysis-dimensions':
      name = 'Analysis Dimension'
      break
    case '/analysis-structures':
      name = 'Analysis Structures'
      break
    case '/vendors':
      name = 'Vendors'
      break
    case `/vendors/${dataId}`:
      name = 'Vendor Card'
      break
    case '/approval-roles':
      name = 'Approval Roles'
      break
    case '/approval-stages':
      name = 'Approval Stages'
      break
    case `/approval-stages/${dataId}`:
      name = 'Approval Stage Card'
      break
    case '/requests':
      name = r("request_list")
      break
    case '/payment':
      name = 'Payments List'
      break
    case `/payment-pay/${dataId}`:
      name = 'Pay'
      break
    case `/payment-create`:
      name = 'Payment Create'
      break
    case `/payment/${dataId}`:
      name = 'Payment Card'
      break
    case `/requests/${dataId}`:
      name = r("request_card")
      break
    case '/rfqs':
      name = 'RFQ List'
      break
    case `/rfqs/${dataId}`:
      name = 'RFQ Card'
      break
    case `/select-request/${dataId}`:
      name = 'Create RFQ'
      break
    case `/bid-comparison`:
      name = 'Chart List'
      break
    case `/invoice-register`:
      name = 'Invoice Register'
      break
    case `/bid-comparison/${dataId}`:
      name = 'Chart Card'
      break
    case '/bids':
      name = 'BIDs List'
      break
    case `/bids/${dataId}`:
      name = 'BIDs Card'
      break
    case `/orders`:
      name = 'Order List'
      break
    case `/ordersList`:
      name = 'Order Create List'
      break
    case `/orders/${dataId}`:
      name = 'Order Card'
      break
    case `/invoice-match/${dataId}`:
      name = 'Invoice Matching'
      break
    case `/invoice-match`:
      name = 'Invoice Matching'
      break
    default:
      name = null
      break
  }


  return (
    <AppBar
      position="static"
      style={{
        zIndex: 5,
        top: (url === '/supplier-evaluation') || (url.startsWith('/supplier-evaluation/')) ? '0' : '63px',
      }}
      sx={{
        position: 'sticky',

        bgcolor: '#D9D9D9',
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme),
      }}
    >
      <Toolbar
        sx={{
          pr: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignContent: 'center',
        }}
      >
        <Grid container direction="row" justifyContent="flex-start" alignItems="center">
          <Typography
            variant="h6"
            style={{ fontWeight: 900 }}
            sx={{ display: { xs: 'none', md: 'block' }, color: 'black' }}
          >
            {name}
          </Typography>
          <Grid item>
            {url !== '/' && url !== '/supplier-evaluation' && url !== `/supplier-evaluation/${dataId}` && url !== ' / requests' && url !== '/orders' && (
              <Button
                onClick={() => clickHandlers.handleBack('back')}
                sx={{ pl: 2 }}
                size="small"
                startIcon={<Icon icon="fluent-mdl2:navigate-back" color="black" />}
              >
                <Typography
                  sx={{
                    display: { xs: 'none', md: 'block' },
                    color: 'black',
                  }}
                >
                  {t('back')}
                </Typography>
              </Button>
            )}
          </Grid>



          <Grid item>
            {/* Dynamic Buttons */}
            {renderedDynamicButton}
          </Grid>
          <Grid item>
            {/* Static Button */}
            {renderedStaticButton}
          </Grid>


          {/* {(url === '/supplier-evaluation' || url === `/supplier-evaluation/${dataId}`) && (
            <Grid item style={{ marginLeft: 'auto' }}>
              <Language color="white" />
            </Grid>
          )} */}
        </Grid>
      </Toolbar>
    </AppBar>
  )
}

export default ButtonList
